import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LANGUAGES } from 'assets/constants';

const normalizeLang = (value) => {
  const lang = (value || "").toLowerCase().split("-")[0];
  return LANGUAGES.includes(lang) ? lang : "sp";
};

function Link(props) {
  const { to, ...rest } = props;

  const lang = normalizeLang(localStorage.getItem("i18nextLng"));

  const path = `/${lang}${to}`;

  return <RouterLink to={path} {...rest} />;
}

export default Link;
